import React from 'react';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

import { LRS_ACTIONS, TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP } from '../../../_shared';

const propTypes = {

	/**
	 * The video resource ID (if any).
	 */
	id: PropTypes.string,

	/**
	 * The Youtube id of the video.
	 */
	youtubeVideoId: PropTypes.string.isRequired,

	/**
	 * The aspect ratio for the video.
	 */
	aspectRatio: PropTypes.string,

	/**
	 * Flag to auto play the video.
	 */
	autoplay: PropTypes.bool,

	/**
	 * Function to handle video watching.
	 */
	onVideoWatch: PropTypes.func,

};

const defaultProps = {
	aspectRatio: TECHCHANGE_DEFAULT_ASPECT_RATIO_BOOTSTRAP,
	autoplay: false,
};

const IframeYoutubePlayer = (props) => {

	const {
		id,
		youtubeVideoId,
		aspectRatio,
		autoplay,
		onVideoWatch,
	} = props;

	const handleYouTubeStateChange = (event) => {

		const currentTime = event.target.getCurrentTime();
		const totalTime = null;

		let status;

		// This corresponds to the onStateChange codes that are provided from the YouTube API.
		// 0 = ended (complete)
		// 1 = played
		// 2 = paused
		// You can see more about these codes (and other codes) here:
		// https://developers.google.com/youtube/iframe_api_reference#onStateChange
		if (event.data === 0) {
			status = LRS_ACTIONS.FINISHED;
		} else if (event.data === 1) {
			status = LRS_ACTIONS.PLAYED;
		} else if (event.data === 2) {
			status = LRS_ACTIONS.PAUSED;
		}

		if (status && onVideoWatch) {

			const metadata = {
				id,
				status,
				currentTime,
				totalTime,
				event,
			};

			onVideoWatch(metadata);

		}

	};

	return (
		<YouTube
			className={`ratio ratio-${aspectRatio}`}
			videoId={youtubeVideoId}
			opts={{
				playerVars: {
					autoplay: autoplay ? 1 : 0,
					showinfo: 0,
					rel: 0,
				}
			}}
			onStateChange={handleYouTubeStateChange} />
	);

};

IframeYoutubePlayer.propTypes = propTypes;
IframeYoutubePlayer.defaultProps = defaultProps;

export default IframeYoutubePlayer;
